"use client"

import { useSearchParams } from "next/navigation"
import { Activity, type ReactNode, useEffect, useState } from "react"
import { getPageBySlug } from "../content/public-content.ts"
import { consumerTabPaths, isConsumerTabPath } from "../lib/consumer-navigation.ts"
import { resolveUserRoute } from "../lib/routes.ts"
import { JourneyClient } from "./journey-client.tsx"

const guidePage = getPageBySlug("guide")

/** Retain our own client views, never Next's URL-bound LayoutRouter children. */
export const ConsumerTabs = ({ children, pathname }: { readonly children: ReactNode; readonly pathname: string }) => {
  const search = useSearchParams()?.toString() ?? ""
  const [visited, setVisited] = useState<Readonly<Record<string, string>>>({})
  const isTab = isConsumerTabPath(pathname)
  useEffect(() => {
    if (isTab) document.title = `${resolveUserRoute(pathname)?.title} | 캐시허브`
  }, [isTab, pathname])
  if (isTab && visited[pathname] !== search) setVisited({ ...visited, [pathname]: search })
  return (
    <>
      {consumerTabPaths.map((path) => {
        const route = resolveUserRoute(path)
        if (route === null || visited[path] === undefined) return null
        const active = pathname === path
        return (
          <Activity key={path} mode={active ? "visible" : "hidden"}>
            <div data-consumer-tab={path} hidden={!active}>
              <JourneyClient {...(path === "/home" && guidePage !== undefined ? { guidePage } : {})} pathname={path} route={route} search={visited[path]} />
            </div>
          </Activity>
        )
      })}
      {isTab ? null : children}
    </>
  )
}
